import { createFileRoute } from '@tanstack/react-router';
import { RestaurantList } from '@/components/RestaurantList/RestaurantList';

export const Route = createFileRoute('/a/restaurants')({
  staticData: {
    breadcrumbs: [{ label: 'Restaurants' }],
  },
  component: Component,
});

function Component() {
  return <RestaurantList showAddRestaurant={true} restaurantLinkPath="/r/$restaurantId" />;
}
